function ProductSkeleton() {
  return (
    <div className="caf-product-card caf-product-skeleton" aria-hidden="true">
      <div className="caf-product-skeleton__media" />
      <div className="caf-product-skeleton__body">
        <div className="caf-product-skeleton__line caf-product-skeleton__line--sm" />
        <div className="caf-product-skeleton__line caf-product-skeleton__line--lg" />
        <div className="caf-product-skeleton__line caf-product-skeleton__line--md" />
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 6 }) {
  return (
    <div className="caf-product-grid">
      {Array.from({ length: count }, (_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
}

export default ProductSkeleton;
